export const DrawerSizeOptions = {
  Third: 'Third',
  Half: 'Half',
  TwoThirds: 'TwoThirds',
  OneThirds: 'OneThirds',
  Full: 'Full',
  Middle: 'Middle',
  Popup: 'Popup'
}
